import { render } from "./TheKnNav.vue?vue&type=template&id=05f4b793&scoped=true&ts=true"
import script from "./TheKnNav.vue?vue&type=script&lang=ts"
export * from "./TheKnNav.vue?vue&type=script&lang=ts"

import "./TheKnNav.vue?vue&type=style&index=0&id=05f4b793&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f4b793"]])

export default __exports__